import { QueryBuilderContext } from "@query-builder/QueryBuilderContext";
import React, { useContext } from "react";
import { hasValue, PillInput } from "uxp/components";
export const DEPillInput = ({ query, value, onChange }) => {
    var _a;
    const context = useContext(QueryBuilderContext);
    const deContext = {
        label: 'Data Explorer Parameters',
        fields: ((query === null || query === void 0 ? void 0 : query.params) || []).map(p => ({
            label: p.name,
            value: `$.deparams.${p.name}`,
            formatters: hasValue(p === null || p === void 0 ? void 0 : p.type) ? [p.type] : undefined
        }))
    };
    const deConfiguration = {
        deparams: {
            valueIndex: 0,
            renderValue(value, allFields) {
                const field = allFields.find(f => (f === null || f === void 0 ? void 0 : f.value) == value);
                if (field)
                    return field.label;
                return value;
            },
            icon: 'fas sliders-h',
            backgroundColor: '#52A1F2',
            textColor: '#FFF'
        }
    };
    const externalSections = (_a = ((context === null || context === void 0 ? void 0 : context.externalContextDataSections) || [])) === null || _a === void 0 ? void 0 : _a.filter(es => !!es);
    const sections = [deContext, ...externalSections];
    const configurations = Object.assign(Object.assign({}, ((context === null || context === void 0 ? void 0 : context.externalPillConfiguration) || {})), deConfiguration);
    console.log('externalcontext', sections, deContext);
    return React.createElement(PillInput, { value: value || '', onChange: onChange, contextDataSections: sections, pillConfiguration: configurations });
};
